import { create } from 'zustand';
import {
    ApplicationRightProps,
    NotificationMessageProps,
    ConfigurationProps,
    HeaderContentProps,
    MapEventProps
    } from '../props';

export interface IAppStoreState {
    isBusy: boolean;
    darkmode: boolean;
    applicationRights: ApplicationRightProps[] | null;
    configuration: ConfigurationProps | null;
    notificationMessage: NotificationMessageProps | null;
    headerContent: HeaderContentProps | null;
    reloadAlerts: boolean;
    closeNotificationMessageId: string | null;
    mapEvent: MapEventProps | null;
    refreshedData: boolean;
    serviceWorkerRegistration: ServiceWorkerRegistration | null;
    isMenuMini: boolean;

    setIsBusy: (data: boolean) => void;
    setDarkmode: (data: boolean) => void;
    setApplicationRights: (data: ApplicationRightProps[]) => void;
    setConfiguration: (data: ConfigurationProps) => void;
    setNotificationMessage: (data: NotificationMessageProps | null) => void;
    setHeaderContent: (data: HeaderContentProps | null) => void;
    setReloadAlerts: (data: boolean) => void;
    setCloseNotificationMessageId: (data: string) => void;
    setMapEvent: (data: MapEventProps | null) => void;
    setRefreshedData: (data: boolean) => void;
    setServiceWorkerRegistration: (data: ServiceWorkerRegistration | null) => void;
    setIsMenuMini: (data: boolean) => void;
}

export const AppStore = create<IAppStoreState>((set) => ({
    isBusy: false,
    darkmode: false,
    applicationRights: null,
    configuration: null,
    notificationMessage: null,
    headerContent: null,
    reloadAlerts: false,
    closeNotificationMessageId: null,
    mapEvent: null,
    refreshedData: false,
    serviceWorkerRegistration: null,
    isMenuMini: false,

    setIsBusy: (data) => set({ isBusy: data }),
    setDarkmode: (data) => set({ darkmode: data }),
    setApplicationRights: (data) => set({ applicationRights: data }),
    setConfiguration: (data) => set({ configuration: data }),
    setNotificationMessage: (data) => set({ notificationMessage: data }),
    setHeaderContent: (data) => set({ headerContent: data }),
    setReloadAlerts: (data) => set({ reloadAlerts: data }),
    setCloseNotificationMessageId: (data) => set({ closeNotificationMessageId: data }),
    setMapEvent: (data) => set({ mapEvent: data }),
    setRefreshedData: (data) => set({ refreshedData: data }),
    setServiceWorkerRegistration: (data) => set({ serviceWorkerRegistration: data }),
    setIsMenuMini: (data) => set({ isMenuMini: data }),
}));

export const createAppStore = () => AppStore;
